import {
    AcceptIcon,
    Button,
    ChevronStartIcon,
    CloseIcon,
    Dialog,
    Flex,
    MenuButton,
    MoreIcon,
    SendIcon,
    SplitButton,
    Text,
    TrashCanIcon,
} from "@fluentui/react-northstar";
import React, { useState } from "react";
import styled from "styled-components/macro";
import { Container } from "../../../../common/styles";
import Reinvoiceable from "../Badges/Reinvoiceable";
import {
    CloudCheckmark16Regular,
    MoneyHandFilled,
} from "@fluentui/react-icons";
import BadgeCodeBudget from "../Badges/BadgeCodeBudget";
import { useTranslation } from "react-i18next";
import { I18N_NS_EXPENSE } from "../../constants";
import { DEVICE, DEVICE_MAX } from "../../../../constants/responsive";
import { useMediaQuery } from "react-responsive";
import { css } from "styled-components";
import ConfirmDialogSendNote from "./ConfirmDialogSendNote";

const HeaderDetail = ({
    title = "",
    reinvoiceable = false,
    client_name = "",
    objectCode = null,
    disabledSendButton = false,
    isSendingNote = false,
    showDotsMenu = true,
    showSaveAuto = true,
    showButtonSendNote = true,
    showButtonsAcceptReject = false,
    onClickCancel = () => {},
    onClickGoBack = () => {},
    onClickSendNote = () => {},
    onClickAcceptNote = () => {},
    onClickRejectNote = () => {},
    onClickAcceptAnotherAmount = () => {},
}) => {
    const isMobile = useMediaQuery({
        query: `(max-width:480px)`,
    });
    const isLessThenTablet = useMediaQuery({
        query: DEVICE_MAX.tablet,
    });

    const [confirmSendNoteDialog, setConfirmSendNoteDialog] = useState(false);

    return (
        <Wrapper>
            <SContainer vAlign="center" hAlign="space-between">
                <Left vAlign="center" gap="gap.medium">
                    <Flex>
                        <Button
                            iconOnly
                            icon={<ChevronStartIcon />}
                            flat
                            size="small"
                            onClick={onClickGoBack}
                        />
                    </Flex>
                    <FirstLine vAlign="center" gap="gap.large">
                        <Title>{title}</Title>
                        {showDotsMenu && showButtonSendNote && (
                            <div>
                                <MenuButton
                                    // onOpenChange={(e, { open }) => null}
                                    trigger={
                                        <SButtonMore
                                            content={<MoreIcon rotate="90" />}
                                            size="small"
                                            text
                                        />
                                    }
                                    menu={[
                                        {
                                            key: 1,
                                            content: "Supprimer la note",
                                            icon: <TrashCanIcon size="small" />,
                                            onClick: () => onClickCancel(),
                                            styles: {
                                                color: "var(--color-danger)",
                                            },
                                        },
                                    ]}
                                />
                            </div>
                        )}
                        {reinvoiceable && (
                            <Reinvoiceable client_name={client_name} />
                        )}
                        {objectCode && <BadgeCodeBudget code={objectCode} />}
                    </FirstLine>
                </Left>
                <Right vAlign="center">
                    {showSaveAuto && (
                        <Flex gap="gap.smaller" vAlign="center">
                            <AutoSave $isMobile={isMobile}>
                                {isMobile
                                    ? "Enregistrée"
                                    : "Enregistrement automatique"}
                            </AutoSave>
                            <CloudCheckmark16Regular color={"#13A10E"} />
                        </Flex>
                    )}

                    <DialogSendNote
                        open={confirmSendNoteDialog}
                        confirmButton={{
                            content: "Confirmer l'envoi",
                            onClick: () => onClickSendNote(),
                            loading: isSendingNote,
                        }}
                        onCancel={() => {
                            setConfirmSendNoteDialog(false);
                        }}
                        cancelButton={{
                            content: "Ne pas envoyer",
                            onClick: () => {
                                setConfirmSendNoteDialog(false);
                            },
                        }}
                        headerAction={{
                            icon: <CloseIcon />,
                            onClick: () => {
                                setConfirmSendNoteDialog(false);
                            },
                        }}
                        header={"Confirmez-vous l'envoi de la note ?"}
                        content={<ConfirmDialogSendNote />}
                        trigger={
                            showButtonSendNote &&
                            !isLessThenTablet && (
                                <SSendNoteButton
                                    content={"Envoyer la note"}
                                    icon={<SendIcon size="small" />}
                                    iconPosition="after"
                                    disabled={disabledSendButton}
                                    primary
                                    flat
                                    onClick={() =>
                                        setConfirmSendNoteDialog(true)
                                    }
                                    // onClick={onClickSendNote}
                                />
                            )
                        }
                    />

                    {showButtonsAcceptReject && !isLessThenTablet && (
                        <WrapperButtonActions vAlign="center" hAlign="center">
                            <SButtonRefuseNote
                                content={"Refuser la note"}
                                disabled={false}
                                secondary
                                flat
                                styles={{ color: "var(--color-danger)" }}
                                // loading={isSendingNote}
                                onClick={onClickRejectNote}
                            />
                            <div>
                                <SButton
                                    content={"Accepter la note"}
                                    primary
                                    flat
                                    onClick={onClickAcceptNote}
                                />
                            </div>
                            {/* <Button
                                content={"Accepter la note"}
                                icon={<SendIcon size="small" />}
                                iconPosition="after"
                                disabled={disabledSendButton}
                                primary
                                flat
                                loading={isSendingNote}
                                onClick={onClickSendNote}
                            /> */}
                        </WrapperButtonActions>
                    )}
                </Right>
            </SContainer>
        </Wrapper>
    );
};

export default HeaderDetail;

export const DialogSendNote = styled(Dialog)``;

export const SSendNoteButton = styled(Button)`
    @media ${DEVICE.mobileS} {
        width: 100%;
        align-self: center;
        margin-right: 0px !important;
    }
    @media ${DEVICE.tablet} {
        width: auto;
    }
`;

export const SButtonRefuseNote = styled(Button)`
    @media ${DEVICE.mobileS} {
        width: 100%;
    }
    @media ${DEVICE.mobileM} {
        width: auto;
    }
`;
export const SButton = styled(Button)``;
export const SSplitButton = styled(SplitButton)`
    @media ${DEVICE.mobileS} {
        width: 100%;
    }
    @media ${DEVICE.mobileM} {
        width: auto;
    }
`;

export const WrapperButtonActions = styled(Flex)`
    @media ${DEVICE.mobileS} {
        flex-direction: column-reverse;
        width: 100%;
        gap: 8px;
    }
    @media ${DEVICE.mobileM} {
        flex-direction: row;
        gap: 40px;
    }
`;

export const SButtonMore = styled(Button)`
    min-width: fit-content;
    padding: 0;
`;

const FirstLine = styled(Flex)`
    @media ${DEVICE.mobileS} {
        flex-wrap: wrap;
        row-gap: 8px;
    }
    @media ${DEVICE.tablet} {
    }
`;

const Right = styled(Flex)`
    @media ${DEVICE.mobileS} {
        width: 100%;
        justify-content: space-between;
        padding-inline: 24px;
        gap: 0px;
    }
    @media ${DEVICE.tablet} {
        width: fit-content;
        padding-inline: 0px;
        gap: 24px;
    }
`;

const Left = styled(Flex)`
    @media ${DEVICE.mobileS} {
        width: 100%;
    }
    @media ${DEVICE.tablet} {
        width: fit-content;
    }
`;

const SContainer = styled(Container)`
    @media ${DEVICE.mobileS} {
        flex-direction: column;
        gap: 8px;
        padding-block: 24px;
        padding-inline: 16px;
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
        padding-block: 0px;
        padding-inline: 0px;
    }
`;

const AutoSave = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );
    text-align: center;
    font-style: normal;
    font-weight: 400;

    ${({ $isMobile }) =>
        $isMobile
            ? css`
                  font-size: 10px;
                  line-height: 12px; /* 120% */
              `
            : css`
                  font-size: 14px;
                  line-height: 19px;
              `}
`;
const Title = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
`;

const Wrapper = styled(Flex)`
    display: flex;
    width: 100%;
    min-height: 64px;

    /* padding: var(--spacing-xs-8, 8px) var(--spacing-xxl-40, 40px); */
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;

    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-tab-bar */
    box-shadow: 1.5px 0px 2px 0px rgba(0, 0, 0, 0.14),
        2.46px 2.46px 4.34px 0px rgba(138, 143, 255, 0.25),
        0.46px 0px 1.38px 0px rgba(68, 71, 193, 0.67);
`;
